import { apiClient } from "../../../services/apiClient";
import { API_ENDPOINTS, PAGINATION } from "../../../config/apiEndpoints";

export const notificationService = {
  getNotifications: async ({ page = 1, limit = PAGINATION.NOTIFICATIONS_PER_PAGE } = {}) => {
    return apiClient.get(API_ENDPOINTS.NOTIFICATIONS.LIST, {
      params: { page, limit },
    });
  },

  getUnreadCount: async () => {
    return apiClient.get(API_ENDPOINTS.NOTIFICATIONS.UNREAD_COUNT);
  },

  markRead: async (id) => {
    return apiClient.put(API_ENDPOINTS.NOTIFICATIONS.MARK_READ(id));
  },

  markAllRead: async () => {
    return apiClient.put(API_ENDPOINTS.NOTIFICATIONS.MARK_ALL_READ);
  },

  deleteNotification: async (id) => {
    return apiClient.delete(API_ENDPOINTS.NOTIFICATIONS.DELETE(id));
  },

  getPreferences: async () => {
    return apiClient.get("/api/Notification/preferences");
  },

  updatePreferences: async (preferences) => {
    return apiClient.put("/api/Notification/preferences", { PREFERENCES: preferences });
  },
};
